import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'navBadgeFormat', standalone: true })
export class NavBadgeFormatPipe implements PipeTransform {
  transform(count: number): string {
    return count > 99 ? '99+' : String(count);
  }
}
